webpackJsonp([65],{

/***/ "1ps6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-company-quote_ae9ee22cc3e2cd7387921110c1a747c4.html";

/***/ }),

/***/ "ukZq":
/***/ (function(module, exports, __webpack_require__) {

var SectionCompanyQuote = (function () {
    function SectionCompanyQuote() {
    }
    return SectionCompanyQuote;
}());
angular.module('animatronApp.sectionCompanyQuote', []).component('sectionCompanyQuote', {
    bindings: {
        username: '<',
        description: '<',
        text: '<',
        avatar: '<',
    },
    controller: SectionCompanyQuote,
    templateUrl: __webpack_require__("1ps6")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/65-28dc41a6a889e793a2e2.min.js